import Project from 'src/entities/Project';
import * as React from 'react';
import ProjectActionToolbarContainer from 'src/modules/project/partials/action-toolbar/ProjectActionToolbar.container';
import HtmlFormater from 'src/utils/htmlFormaterUtil';

interface Props {
  project: Project;
  invest: boolean;
  closedProject: boolean;
}

const ProjectMarketComponent: React.StatelessComponent<Props> = (props: Props) => (
    <div className="col-sm-9">
      <div className="padding-left-30">
        <div className="gap-50"/>

        <h3>
          Mercado
        </h3>
        <div className="gap-20"/>
        <div className="row">
          <div className="col-msm12">
            <div
              className="from-rich-editor"
              dangerouslySetInnerHTML={{__html: props.project.marketData 
                ? HtmlFormater.parseMarkDownImages(props.project.marketData) : ''}}
            />
          </div>
        </div>
      </div>
      <div className="gap-300"/>
      <ProjectActionToolbarContainer
        project={props.project}
        invest={props.invest}
        closedProject={props.closedProject}
      />
      <div className="gap-50"/>
    </div>
  )
;

export default ProjectMarketComponent;



// WEBPACK FOOTER //
// ./src/modules/project/partials/ProjectMarket.component.tsx